// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"5d2a5dac","453":"4edb15ee","777":"4965acb8"}[chunkId] + ".chunk.js";
};